// src/utils/appointmentDisplay.js
//
// Display helpers for the doctor's appointment page: the status vocabulary
// (same badge classes the appointments list uses) and date/time formatting for
// the values GET /appointments/{id} returns.

export const STATUS_META = {
  SCHEDULED: { label: 'Scheduled', cls: 'badge-confirmed' },
  CONFIRMED: { label: 'Confirmed', cls: 'badge-active' },
  COMPLETED: { label: 'Completed', cls: 'badge-active' },
  CANCELLED: { label: 'Cancelled', cls: 'badge-inactive' },
  PENDING: { label: 'Pending', cls: 'badge-pending' },
  ARRIVED: { label: 'Arrived', cls: 'badge-pending' },
  IN_CONSULTATION: { label: 'In consultation', cls: 'badge-purple' },
  NO_SHOW: { label: 'No show', cls: 'badge-inactive' },
};
export const statusMeta = status => STATUS_META[status] || STATUS_META.SCHEDULED;

/** Statuses an appointment can no longer be closed out from. */
export const CLOSED_STATUSES = ['COMPLETED', 'NO_SHOW', 'CANCELLED'];

export function initials(first = '', last = '') {
  return `${first[0] || ''}${last[0] || ''}`.toUpperCase();
}

const toDate = value => {
  if (!value) return null;
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? null : d;
};

export function fmtLongDate(value) {
  if (!value) return '—';
  const d = toDate(value);
  return d ? d.toLocaleDateString('en-IN', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' }) : String(value);
}

/** "Fri 30 Oct" — for the one-line header. */
export function fmtShortDay(value) {
  const d = toDate(value);
  return d ? d.toLocaleDateString('en-IN', { weekday: 'short', day: 'numeric', month: 'short' }) : '';
}

export function fmtTimestamp(value) {
  if (!value) return '—';
  const d = toDate(value);
  return d ? d.toLocaleString('en-IN', { day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' }) : String(value);
}

/** appointmentTime arrives as a LocalTime ("14:30:00") — trim the seconds. */
export function fmtTime(value) {
  if (!value) return '—';
  const m = String(value).match(/^(\d{2}):(\d{2})/);
  return m ? `${m[1]}:${m[2]}` : String(value);
}

/** Enum-ish server values (FOLLOW_UP, VIDEO_CALL) read badly as-is. */
export function humanise(value) {
  if (!value) return '—';
  return String(value).replace(/_/g, ' ').toLowerCase().replace(/^\w/, c => c.toUpperCase());
}

/** Whole minutes from an API timestamp to `now`; null when unknown or in the future. */
export function minutesSince(value, now = new Date()) {
  const d = toDate(value);
  if (!d) return null;
  const mins = Math.floor((now.getTime() - d.getTime()) / 60000);
  return mins < 0 ? null : mins;
}
